import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

const timeModule: ModuleManifest = {
  id: 'P13',
  name: 'Time Tracking',
  shortName: 'Time',
  description: 'Time tracking, GPS capture, timesheet approval, and payroll export',
  icon: '⏱',
  status: 'live',
  urlPrefix: '/time',
  routes,
  navItems,
  collections: {
    TIME_RECORDS: 'timeRecords',
    TIME_OFF_REQUESTS: 'timeOffRequests',
    HOLIDAYS: 'holidays',
    PAY_RATE_CONFIG: 'payRateConfig',
    PAY_PERIOD_SUMMARIES: 'payPeriodSummaries',
    PAYROLL_EXPORTS: 'payrollExports',
  },
};

export default timeModule;
